import React from "react";

export default function Root(props) {
  return <section>{props.name} is mounted!</section>;
}
